import { useBlocker } from "react-router-dom";
import ConfirmationModal from "../../ui/Modal/ConfirmationModal";
import Modal from "../../ui/Modal/Modal";
import { useCallback, useState } from "react";

function UnsavedChangesModal({
  isDirty,
  onDiscard,
}: {
  isDirty: boolean;
  onDiscard?: () => void | Promise<void>;
}) {
  const [loading, setLoading] = useState(false);
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    const state: unknown = nextLocation.state;

    const block = isDirty && currentLocation.pathname !== nextLocation.pathname;

    if (state && typeof state === "object" && "ignoreBlocker" in state) {
      return block && !state.ignoreBlocker;
    }

    return block;
  });

  const isOpen = blocker.state === "blocked";

  const onClose = useCallback(() => blocker.reset?.(), [blocker]);

  const onProceed = useCallback(async () => {
    setLoading(true);
    await onDiscard?.();
    blocker.proceed?.();
    setLoading(false);
  }, [blocker, onDiscard]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Discard changes?"
      subtitle="You have unsaved changes that will be discarded if you continue."
    >
      <ConfirmationModal
        onClose={onClose}
        onSubmit={onProceed}
        loading={loading}
        confirmationText="Discard"
        destructive
      />
    </Modal>
  );
}

export default UnsavedChangesModal;
